define('TescoMobile_Checkout/js/action/credit-check',['jquery', 'mage/storage', 'Magento_Checkout/js/model/url-builder', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/error-processor', 'Magento_Checkout/js/model/full-screen-loader', 'Magento_Customer/js/model/customer', '../model/create-device-fingerprint-url', 'TescoMobile_Iovation/js/action/wait-for-device-fingerprint', 'TescoMobile_Iovation/js/model/device-fingerprint-config'], function ($, storage, urlBuilder, quote, errorProcessor, fullScreenLoader, customer, createDeviceFingerPrintUrl, waitForDeviceFingerprint, fingerprintConfig) {
  'use strict';

  function creditCheck(serviceUrl, messageContainer) {
    return storage.get(serviceUrl).fail(function (response) {
      errorProcessor.process(response, messageContainer);
    }).always(function () {
      fullScreenLoader.stopLoader();
    });
  }
  return function (messageContainer) {
    const serviceUrl = customer.isLoggedIn() ? urlBuilder.createUrl('/carts/mine/credit-check', {}) : urlBuilder.createUrl('/guest-carts/:cartId/credit-check', {
      cartId: quote.getQuoteId()
    });
    fullScreenLoader.startLoader();
    return fingerprintConfig.isFingerprintSaved || !fingerprintConfig.isRetryVersionEnabled ? creditCheck(serviceUrl, messageContainer) : waitForDeviceFingerprint({
      deviceFingerprintUrl: createDeviceFingerPrintUrl(),
      callback: creditCheck,
      callbackArguments: [serviceUrl, messageContainer]
    });
  };
});

